import React, { forwardRef } from 'react';
import styles from './mobileOrganizationCard.module.scss';
import { IOrganization } from '@source/api/models/nursingHomeModels';

interface MobileOrganizationCardProps {
  organization: IOrganization;
  onClick: (organization: IOrganization) => void;
}

const MobileOrganizationCard = forwardRef<HTMLDivElement, MobileOrganizationCardProps>((props, ref) => {
  const { organization, onClick } = props;

  return (
    <div
      className={styles.card}
      ref={ref}
      onClick={() => onClick(organization)}
    >
      <div className={styles.cardHeader}>
        <div className={styles.nameSection}>
          <div className={styles.name}>{organization.name}</div>
        </div>
      </div>

      <div className={styles.cardBody}>
        <div className={styles.infoGrid}>
          <div className={styles.infoRow}>
            <span className={styles.label}>Description</span>
            <span className={styles.value}>{organization.description || '-'}</span>
          </div>
        </div>
      </div>
    </div>
  );
});

MobileOrganizationCard.displayName = 'MobileOrganizationCard';

export default MobileOrganizationCard;
